module.exports = __webpack_public_path__ + "static/media/buyu_m_game.b2dab1d.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/gameVideo/buyu_m_game.mp4
// module id = +ZNz
// module chunks = 0